@reference "@glow/tailwind-config/reference.css";

.wrapper {
  @apply inline-block;
  @apply relative;
}

.showTooltip {
  @apply !visible;
}

.tooltip {
  @apply absolute;
  @apply -top-7;
  @apply -translate-x-1/2;
  @apply px-3;
  @apply py-1;
  @apply flex;
  @apply justify-center;
  @apply items-center;
  @apply rounded-sm;
  @apply z-[1002];
  @apply bg-gray-600;
  @apply text-white;
  @apply text-xs;
  @apply font-normal;
  @apply invisible;
  @apply whitespace-nowrap;
}
